import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { urlApi } from '../Constants/Global';
import { Navbar, Nav, Container, Offcanvas } from 'react-bootstrap';
import $ from 'jquery';
import { BiPhoneCall } from 'react-icons/bi';

export class SectionNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      icon_size: 28, 
      showOffcanvas: false
    }
  }

  async componentDidMount() {
    $(document).ready(function(){
      $(window).scroll(function(){
        if(window.scrollY > 0){
          $(".navbar").addClass("viewing-content");
        }else{
          $(".navbar").removeClass("viewing-content");
        }
      });
    });
  }

  scrollToTarget(v_target) {
    var target = document.getElementById(v_target);
    window.scrollTo({
      top: target.offsetTop - 125, 
      behavior: 'smooth'
    });
    this.closeOffcanvas();
  }

  async changeLanguage(v_lang) {
    console.log("componentDidMount", urlApi + "/?module=web&call=language-change", v_lang);
    var form_data = new FormData();
    form_data.append("lang", v_lang);

    const url = urlApi + "/?module=web&call=language-change";
    await fetch(url, {
      method: 'POST', 
      body: form_data
    })
      .then(res => res.json())
      .then(result => {
        console.log("changeLanguage", result);
        window.location.reload();
      });
  }

  openOffcanvas = () => {
    this.setState({
      showOffcanvas: true,
    });
  };

  closeOffcanvas = () => {
    this.setState({
      showOffcanvas: false,
    });
  };

  render() {
    return (
      <>
        <Navbar expand="lg" sticky="top" bg="white" className="flex-column pt-0 pb-0">
          <Container fluid className="pt-2 pb-2 px-3">
            <Navbar.Brand href="/">
              <img src={this.props.logo} className="logo" alt="LD Plastpack Logo" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="offcanvasNavbar" className="ms-0 ms-sm-3" onClick={this.openOffcanvas} />
            <Navbar.Offcanvas
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
              placement="end"
              show={this.state.showOffcanvas} 
              onHide={this.closeOffcanvas}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvasNavbarLabel">
                  {this.props.lang === 'th' ? 'เมนูหลัก' : 'Main menu'}
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1">
                  <Link to="/" className="nav-link active">{this.props.lang === 'th' ? 'HOME' : 'HOME'}</Link>
                  <Nav.Link onClick={() => this.scrollToTarget("why")}>{this.props.lang === 'th' ? 'WHY US' : 'WHY US'}</Nav.Link>
                  <Nav.Link onClick={() => this.scrollToTarget("service")}>{this.props.lang === 'th' ? 'SERVICES' : 'SERVICES'}</Nav.Link>
                  <Nav.Link onClick={() => this.scrollToTarget("about")}>{this.props.lang === 'th' ? 'ABOUT US' : 'ABOUT US'}</Nav.Link>
                  <Nav.Link onClick={() => this.scrollToTarget("product")}>{this.props.lang === 'th' ? 'PRODUCTS' : 'PRODUCTS'}</Nav.Link>
                  <button className='btn btn-sm ibt-primary px-3 ms-2 d-inline-block' onClick={() => this.scrollToTarget("contact")}>
                    <BiPhoneCall size={this.state.icon_size} color={'#FFF'}/> {this.props.lang === 'th' ? 'CONTACT US' : 'CONTACT US'}
                  </button>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      </>
    )
  }
}

export default SectionNavbar